import { flowConfig } from "../config/flowConfigs";

export const renderRoot: HTMLElement = document.getElementById("root") as HTMLElement;
export const templateFlowEngine: HTMLTemplateElement =
  ((flowConfig.templateId && document.getElementById(flowConfig.templateId)) as HTMLTemplateElement) ||
  (document.getElementById("templateFlowEngine") as HTMLTemplateElement);
export const templateError: HTMLTemplateElement = document.getElementById("templateError") as HTMLTemplateElement;
